import classNames from 'classnames';
import { ReactNode } from 'react';

import { CheckBigIcon, CircleIcon } from '@/components';
interface Props {
  icon?: ReactNode;
  checkedIcon?: ReactNode;
  name: string;
  id: string;
  checked: boolean;
  onClick: (item: { name: string; id: string }) => void;
  className?: string;
  disabled?: boolean;
}
export function CheckItem(props: Props) {
  const { icon, checkedIcon, checked, name, id, onClick, className, disabled } = props;
  return (
    <div
      className={classNames(
        'p-4 mb-3 border border-gray-200 rounded-md flex flex-row justify-between items-center',
        className,
        {
          'border-primary-600': checked,
          'bg-primary-50': checked,
          'bg-gray-100': disabled,
          'border-gray-100': checked
        }
      )}
      onClick={() => {
        !disabled && onClick({ name, id });
      }}
    >
      <div className="flex flex-row justify-start items-center cursor-pointer">
        {checked ? checkedIcon : icon}
        <span
          className={classNames('text-md font-medium text-gray-700 ml-3 max-w-[250px] truncate', {
            'text-primary-800': checked
          })}
          title={name}
        >
          {name}
        </span>
      </div>
      {disabled ? (
        <span className="text-xs font-normal text-gray-500">Current Folder</span>
      ) : checked ? (
        <CheckBigIcon />
      ) : (
        <CircleIcon />
      )}
    </div>
  );
}
